let _ = require('../../src/js/auction/_.js');
let $ = jQuery;

let _options = {
    multitrack: null,
    multiple_agents: null,
    auction_is_choice: false,
    // round_is_complete: false,
    auction_is_complete: false,
}

let _state = {
    status_is_in_bidder_area: false
}

_.landproz_layout_set_options = function (options) {

    let has_changed = false;

    for (let i in options) {
        if (_options[i] !== options[i]) {
            has_changed = true;
        }
    }

    if (has_changed) {
        _.landproz_layout_handler(true);

        for (let i in options) {
            _options[i] = options[i];
        }

        _.landproz_layout_handler();
    }
}

let old_state = null;
let current_state = null;
let current_state_wide_description = false;

let has_first_run = false;

_.landproz_layout_handler = function (reset = false) {

    if (!has_first_run) {
        has_first_run = true;
    }

    let is_interactive_auction = !(_.ac_state && _.ac_state.auction && _.ac_state.auction.is_online_auction);

    // const window_width = $(window).width();
    // const gallery = $('#landproz-auctioncast-gallery');
    // const itemsbox = $('.is_auction_items_col');
    // const itemsboxinner = $('.ac-component-bid-auction-lots');
    // const itemsboxitems = $('.ac-component-bid-auction-lots-items');
    // const lower1 = $(".ac-component-bid-auction-signin-detail");
    // // const lower2 = itemsboxinner.find(".ac-component-bid-auction-lots-items-lower-2");
    // const auctionbox = $("#landproz-auctioncast-auction");

    // Doesnt work because gallery doesnt resolve right away
    // const referenceRect = gallery[0].getBoundingClientRect();
    // const referenceHeight = referenceRect.bottom - referenceRect.top;
    // let itemsNewHeight = Math.round(referenceHeight) - 35;

    function on_large() {
        // Match height of bidding to gallery
        $("#landproz-auctioncast-auction-bidding").css('min-height', ($(".ac-box-a").outerHeight() - $("#landproz-auctioncast-auction").outerHeight()) + "px");

        // Match height of tracts to bidding
        $(".ac-box-wrapper-b").css('height', $(".ac-box-wrapper-c").outerHeight() + "px");
        $(".ac-box-b").css('height', "100%");
    }

    function on_medium() {
        $(".ac-box-wrapper-a").css('margin-right', '20px');

        // if (window.matchMedia("(min-width: 1950px)").matches) {
        //     $(".ac-box-wrapper-b").css('min-width', '800px');
        // } else {
        //     $(".ac-box-wrapper-b").css('min-width', '');
        // }

        if (_options.multitrack && window.matchMedia("(max-width: 1600px)").matches) {
            $(".landproz-auctioncast-agent").css('margin-left', "0px");
            $(".landproz-auctioncast-agent").css('margin-right', "0px");
        } else {
            $(".landproz-auctioncast-agent").css('margin-left', "");
            $(".landproz-auctioncast-agent").css('margin-right', "");
        }


        // Match height of tracts to bids
        if (_options.multitrack) {
            $(".ac-box-b").css('max-height', $(".ac-box-c").innerHeight() + "px");
        }

        if (_options.multitrack && $(".landproz-auctioncast-agent").length) {
            // $(".ac-box-wrapper-a").css('width', ($(".landproz-auction-panels").outerWidth() - $(".landproz-auctioncast-agent").first().outerWidth() - 20) + 'px')
        }
    }

    function on_small() {

    }

    function transition_to_large() {
        if (_options.multitrack) {
            $("#landproz-auctioncast-agents").addClass('agents-inline');
        } else {
            $(".ac-box-b").hide();
            $("#landproz-auctioncast-agents").appendTo(".ac-box-wrapper-b");
            if (_options.multiple_agents) {
                $("#landproz-auctioncast-agents").addClass('agents-wide');
                $(".ac-box-wrapper-b").css('width', '500px');
            } else {
                $("#landproz-auctioncast-agents").addClass('agents-tall');
                $(".ac-box-wrapper-b").css('width', '350px');
            }
            // Swap zone b and c
            $(".ac-box-wrapper-b").appendTo(".landproz-auction-panels");
        }
    }

    function transition_from_large() {
        if (!_options.multitrack) {
            $(".ac-box-b").show();
            // Restore agents into zone d
            $("#landproz-auctioncast-agents").appendTo(".ac-box-wrapper-d");
            // Swap back zone c after zone b
            $(".ac-box-wrapper-c").appendTo(".landproz-auction-panels");
            $(".ac-box-wrapper-b").css('width', '');
        }
        $("#landproz-auctioncast-agents").removeClass('agents-inline');
        $("#landproz-auctioncast-agents").removeClass('agents-tall');
        $("#landproz-auctioncast-agents").removeClass('agents-wide');
        $(".ac-box-wrapper-b").css('height', "");
        $(".ac-box-b").css('height', "");
        $("#landproz-auctioncast-auction-bidding").css('min-height', "");
    }

    function transition_to_medium() {
        // If single track, bidding in box b.  If multitrack, agents in box b, items and bidding both in c.
        if (_options.multitrack) {
            // Move tracks below top row, to the left of bidding
            $(".ac-box-wrapper-c").prepend(
                $(".ac-box-b")
            );

            // Move agents to right of gallery and apply formatting
            if (_options.multiple_agents) {
                $("#landproz-auctioncast-agents").addClass('agents-wide');
            } else {
                $("#landproz-auctioncast-agents").addClass('agents-tall');
            }

            $("#landproz-auctioncast-agents").appendTo(".ac-box-wrapper-b");

            if (!_options.multiple_agents) {
                $(".landproz-auction-panels").addClass("landproz-auction-panels-single-agent-medium-special");
            }

        } else {
            $(".ac-box-b").hide();
            $(".ac-box-c").appendTo(".ac-box-wrapper-b");
            $("#landproz-auctioncast-agents").addClass('agents-inline');
            $(".ac-box-c").css('padding-left', '30px');
            // $(".ac-box-c").css('margin-right', '0px');
            $(".ac-box-c").css('width', '100%');
        }
    }

    function transition_from_medium() {
        if (_options.multitrack) {
            $(".ac-box-b").appendTo(".ac-box-wrapper-b");
            $("#landproz-auctioncast-agents").appendTo(".ac-box-wrapper-d");
            if (!_options.multiple_agents) {
                $(".landproz-auction-panels").removeClass("landproz-auction-panels-single-agent-medium-special");
            }
        } else {
            $(".ac-box-b").show();
            $(".ac-box-c").appendTo(".ac-box-wrapper-c");
            $(".ac-box-c").css('padding-left', '');
            // $(".ac-box-c").css('margin-right', '');
            $(".ac-box-c").css('width', '');
            $(".ac-box-wrapper-b").css('min-width', '');
        }

        $("#landproz-auctioncast-agents").removeClass('agents-inline');
        $("#landproz-auctioncast-agents").removeClass('agents-wide');
        $("#landproz-auctioncast-agents").removeClass('agents-tall');
        $(".ac-box-wrapper-a").css('margin-right', '');
        $(".ac-box-wrapper-b").css("min-width", "");
        $(".landproz-auctioncast-agent").css('margin-left', "");
        $(".landproz-auctioncast-agent").css('margin-right', "");
        $(".ac-box-b").css('max-height', '');

    }

    function transition_to_small() {
        $("#landproz-auctioncast-agents").addClass('agents-wide');
        if (!_options.multitrack) {
            $(".ac-box-b").hide();
        }
    }

    function transition_from_small() {
        $("#landproz-auctioncast-agents").removeClass('agents-wide');
        if (!_options.multitrack) {
            $(".ac-box-b").show();
        }
    }

    function transition_to_desktop_standard_listing() {

        $("#landproz-auctioncast-agents").appendTo(".ac-box-wrapper-b");

        if (_options.multiple_agents) {
            $("#landproz-auctioncast-agents").addClass('agents-wide');
        } else {
            $("#landproz-auctioncast-agents").addClass('agents-tall');
        }

        $(".landproz-auction-panels").addClass('landproz-auction-panels-standard-listing');

        $(".ac-box-wrapper-c").hide();
    }

    function transition_from_desktop_standard_listing() {
        $("#landproz-auctioncast-agents").appendTo(".ac-box-wrapper-d");

        $("#landproz-auctioncast-agents").removeClass('agents-inline');
        $("#landproz-auctioncast-agents").removeClass('agents-wide');
        $("#landproz-auctioncast-agents").removeClass('agents-tall');

        $(".landproz-auction-panels").removeClass('landproz-auction-panels-standard-listing');

        $(".ac-box-wrapper-c").show();
    }

    // Bidding status should be in bid window if choice, or mobile viewport
    function update_status_area_placement() {
        let desired_state = 'top';
        if (_options.auction_is_choice || current_state == 'small') {
            if (!_state.status_is_in_bidder_area) {
                $(".ac-bids-bigauctionstatus-group-item").appendTo($(".ac-bids-bigauctionstatus-group-bidding"));
                _state.status_is_in_bidder_area = true;
            }
        } else {
            if (_state.status_is_in_bidder_area) {
                $(".ac-page-lot-facts-title").after($(".ac-bids-bigauctionstatus-group-item"));
                _state.status_is_in_bidder_area = false;
            }

        }
    }

    $(".agents-inline").find(".landproz-auctioncast-agent-content-wrap").each(function () {
        // if ($(this).find(".agent-subtitle").height() >= 50) {
        //     $(this).find(".agent-info-group").addClass("agent-info-group-flex");
        // } else {
        //     $(this).find(".agent-info-group").removeClass("agent-info-group-flex");
        // }
    });


    // ------------------------------------------

    // Identify current size
    if (reset) {
        current_state = null;
    } else if (is_interactive_auction && window.matchMedia("(min-width: 1250px)").matches) {
        current_state = 'desktop_standard_listing';
    } else if (window.matchMedia("(min-width: 2200px)").matches) {
        current_state = 'large';
    } else if (window.matchMedia("(min-width: 1250px)").matches) {
        current_state = 'medium';
    } else {
        current_state = 'small';
    }

    // Happens once on load, and between each transition
    if (old_state != current_state) {
        if (old_state == 'desktop_standard_listing') {
            transition_from_desktop_standard_listing();
        } else if (old_state == 'small') {
            transition_from_small();
        } else if (old_state == 'medium') {
            transition_from_medium();
        } else if (old_state == 'large') {
            transition_from_large();
        }

        if (current_state == 'desktop_standard_listing') {
            transition_to_desktop_standard_listing();
        } else if (current_state == 'small') {
            transition_to_small();
        } else if (current_state == 'medium') {
            transition_to_medium();
        } else if (current_state == 'large') {
            transition_to_large();
        }
    }

    if (current_state == 'large') {
        on_large();
    } else if (current_state == 'medium') {
        on_medium();
    } else if (current_state == 'small') {
        on_small();
    }

    // clone
    old_state = current_state;

    // Handle 'wide descriptions' - sizes between 1600 and 2200.
    let old_wide_description = current_state_wide_description ? true : false; // clone

    current_state_wide_description = false;
    if ((window.matchMedia("(min-width: 1600px)").matches && !window.matchMedia("(min-width: 2200px)").matches && _options.multitrack) ||
        (window.matchMedia("(min-width: 1000px)").matches && !window.matchMedia("(min-width: 1250px)").matches)) {
        current_state_wide_description = true;
    }

    if (old_wide_description != current_state_wide_description) {
        if (old_wide_description) {
            // Reset
            $(".ac-bids-bigauctionstatus-group-item").prependTo($(".landproz-auctioncast-auction-main-container"));
            $(".ac-page-lot-facts-title").prependTo($(".landproz-auctioncast-auction-main-container"));
            $(".ac-page-lot-facts-title").css('top', "-5px");
            $(".ac-page-lot-gallery").appendTo($(".ac-component-bid-auction-lots-details"));
            $(".auction-description-left").css('width', '');
            $(".auction-description-right").css('border-right', '');
            $(".auction-description-right").css('width', '');
            $(".ac-page-lot-description").css('width', '');
            $(".auction-description-left").after($(".auction-description-right"));
            $(".ac-page-lot-facts-featured-photo-thumbnail").css("margin-top", "");
            $(".ac-component-item-detail").css("padding-left", "");
            $(".ac-component-item-detail").css("padding-right", "");
            $(".ac-page-lot-gallery").css("margin-left", "");
            $(".ac-page-lot-gallery").css("margin-right", "");
        } else if (current_state_wide_description) {
            // Set
            $(".ac-bids-bigauctionstatus-group-item").prependTo($(".auction-description-right"));
            $(".ac-page-lot-facts-title").prependTo($(".auction-description-right"));
            $(".ac-page-lot-facts-title").css('top', "-10px");
            $(".ac-page-lot-gallery").appendTo($(".auction-description-left"));
            $(".auction-description-left").css('width', '45%');
            $(".auction-description-right").css('width', '55%');
            $(".auction-description-right").css('border-right', '3px solid #ccc');
            $(".ac-page-lot-description").css('width', '88%');
            $(".auction-description-right").after($(".auction-description-left"));
            $(".ac-page-lot-facts-featured-photo-thumbnail").css("margin-top", "12px");
            $(".ac-component-item-detail").css("padding-left", "0px");
            $(".ac-component-item-detail").css("padding-right", "0px");
            $(".ac-page-lot-gallery").css("margin-left", "5px");
            $(".ac-page-lot-gallery").css("margin-right", "5px");
        }
    }

    // Handle single row buttons - these work between 680-2200
    // 
    // if (window.matchMedia("(min-width: 680px)").matches && !window.matchMedia("(min-width: 2200px)").matches) {
    //     $(".ac-component-user-action-buttons .btn").css('min-width', '0px');
    // } else {
    //     $(".ac-component-user-action-buttons .btn").css('min-width', '');
    // }

    if (_options.multitrack) {
        $(".ac-component-bid-auction-lots").show();
    } else {
        $(".ac-component-bid-auction-lots").hide();
    }

    update_status_area_placement();
}

_.on_ui_resize(_.landproz_layout_handler);

setInterval(_.landproz_layout_handler, 2000);
